export default "__VITE_ASSET__DBDImD3b__"